export const fmt      = (p: number) => `₹${(p / 100).toLocaleString("en-IN")}`;
